const LAYER_ADDED = 'layer-added';
const LAYER_REMOVED = 'layer-removed';
const FILTER_ADDED = 'filter-added';
const REMOVE_ALL_FILTERS = 'remove-all-filters';
const MARKER_CLICKED = 'marker-clicked';
const OPEN_MODAL = 'open-modal';
const CLOSE_MODAL = 'close-modal';
const OPEN_SIDE_PANEL = 'open-side-panel';
const CLOSE_SIDE_PANEL = 'close-side-panel';
const OPEN_LAYER_CONTROL = 'open-layer-control';
const CLOSE_LAYER_CONTROL = 'close-layer-control';
const ZOOM_IN = 'zoom-in';
const ZOOM_OUT = 'zoom-out';
const RECORD_PLAYING = 'record-playing';
const RECORD_STOPPED_PLAYING = 'record-stopped-playing';
const CLOSING_MODAL = 'closing-modal';
const AUDIO_SRC_FETCHED = 'audio-src-fetched';
const RASTER_ADDED = 'raster-added';
const RASTER_REMOVED = 'raster-removed';
const PRINT_MAP = 'print-map';
const SEARCH_SELECTED = 'search-selected';
const SEARCH_REMOVED = 'search-removed';
const SEARCH_WITH_BOUNDS_CHANGE = 'search-with-bounds-change';
const REMOVE_LAYER_PANEL_LOADER = 'remove-layer-panel-loader';
const CHANGE_CUSTOM_MARKER_COLOR = 'change-custom-marker-color';

export {
	LAYER_ADDED,
	LAYER_REMOVED,
	FILTER_ADDED,
	REMOVE_ALL_FILTERS,
	MARKER_CLICKED,
	OPEN_MODAL,
	CLOSE_MODAL,
	OPEN_SIDE_PANEL,
	CLOSE_SIDE_PANEL,
	OPEN_LAYER_CONTROL,
	CLOSE_LAYER_CONTROL,
	ZOOM_IN,
	ZOOM_OUT,
	RECORD_PLAYING,
	RECORD_STOPPED_PLAYING,
	CLOSING_MODAL,
	AUDIO_SRC_FETCHED,
	RASTER_ADDED,
	RASTER_REMOVED,
	PRINT_MAP,
	SEARCH_SELECTED,
	SEARCH_REMOVED,
	SEARCH_WITH_BOUNDS_CHANGE,
	REMOVE_LAYER_PANEL_LOADER,
	CHANGE_CUSTOM_MARKER_COLOR,
};
